module.exports = __webpack_public_path__ + "static/media/location_place-min.ee5ef765.jpg";